// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSubscriptionProcessInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/admin/subscriptions/{id}/process (S12/#17a)
 *
 * No body — the subscription id is a URL path parameter. Nothing else is
 * accepted: the clock and the cut policy belong to the mechanism, not to the
 * caller (see Subscriptions_AdminSweepRunInput for the same reasoning).
 *
 * It exists so the frontend composable can satisfy the canonical
 * `inputContract` option (same precedent as Subscriptions_EventReprocessInput),
 * not because there is anything to validate.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminSubscriptionProcessInput {}

registerContract('Subscriptions_AdminSubscriptionProcessInput', {})
